import listActions from 'src/modules/categoria/list/categoriaListActions';
import CategoriaService from 'src/modules/categoria/categoriaService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'CATEGORIA_DESTROY';

const categoriaDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaDestroyActions.DESTROY_STARTED,
      });

      await CategoriaService.destroyAll([id]);

      dispatch({
        type: categoriaDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.categoria.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/categoria');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: categoriaDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaDestroyActions.DESTROY_ALL_STARTED,
      });

      await CategoriaService.destroyAll(ids);

      dispatch({
        type: categoriaDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.categoria.destroyAll.success'),
      );

      getHistory().push('/categoria');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: categoriaDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default categoriaDestroyActions;
